import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import dateFormat from "dateformat";

import { Calendar } from "@components/index";
import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";
import greenArrow from "@/assets/icons/arrowCalendarRightGreen.svg";

import styles from "./RacketRentCalendar.module.scss";

import { setRentDateToStorage } from "@utils/index";
import { RacketRentCalendarPropsType } from "./types";
import { setRacketTypeToStorage } from "@/utils/storage/racketType";

export const RacketRentCalendar: React.FC<RacketRentCalendarPropsType> = ({ title }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const windowWidth = useCurrentWidth();
  const isMobile = windowWidth <= MediaBreakPoints.MOBILE_LARGE;

  const [typeRacket, setTypeRacket] = useState<string | null>(null);

  const handleTypeRacket = (type: string) => {
    setTypeRacket(type);
    setRacketTypeToStorage(type);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const handleSelectDate = (calendarDate: Date) => {
    const date = dateFormat(calendarDate, "isoDate");
    setRentDateToStorage(date);
    if (typeRacket) {
      setRacketTypeToStorage(typeRacket);
    }
    navigate("/services/racket-calendar/time-and-racket");
  };

  // На мобильных: сначала показываем карточки выбора типа, потом календарь
  if (isMobile && typeRacket === null) {
    return (
      <div>
        <section className="container">
          <div className={styles.mobileCardList}>
            <div className={styles.mobileCard} onClick={() => handleTypeRacket("tennis")}>
              <div className={styles.mobileCardContent}>
                <div className={styles.mobileCardTitleRow}>
                  <span className={styles.mobileCardTitle}>Теннисные ракетки</span>
                  <img src={greenArrow} alt="" className={styles.mobileCardArrow} />
                </div>
                <span className={styles.mobileCardDescription}>Арендуйте ракетки для игры в теннис</span>
              </div>
            </div>
            <div className={styles.mobileCard} onClick={() => handleTypeRacket("padel")}>
              <div className={styles.mobileCardContent}>
                <div className={styles.mobileCardTitleRow}>
                  <span className={styles.mobileCardTitle}>Padel ракетки</span>
                  <img src={greenArrow} alt="" className={styles.mobileCardArrow} />
                </div>
                <span className={styles.mobileCardDescription}>Арендуйте ракетки для игры в padel</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div>
      <section className="container">
        <div className={styles.calendarWrapper}>
          {!isMobile && (
            <ul className={styles.typeRacketList}>
              <li className={`${styles.typeRacketTitle} ${(!typeRacket || typeRacket === "tennis") ? styles.active : ""}`}
                onClick={() => handleTypeRacket("tennis")}
              >
                Теннисные ракетки
              </li>
              <li className={`${styles.typeRacketTitle} ${typeRacket === "padel" ? styles.active : ""}`}
                onClick={() => handleTypeRacket("padel")}
              >
                Padel ракетки
              </li>
            </ul>
          )}
          <Calendar onSelectDate={handleSelectDate} />
        </div>
      </section>
    </div>
  );
};
